// src/components/BookLayout.tsx
import React, { useState, useEffect } from 'react';
import { getChapterMetadata, getTotalPages } from '../utils/contentLoader';
import { useChapterContent } from '../hooks/useChapterContent';
import { useTokenBalance } from '../hooks/useTokenBalance';
import { Sidebar } from './Sidebar';
import { BookContent } from './BookContent';
import { PageNavigation } from './PageNavigation';
import RoadmapView from './RoadmapView';

const BookLayout = () => {
  const [currentView, setCurrentView] = useState<'book' | 'roadmap'>('book');
  const [chapterList, setChapterList] = useState([]);

  const {
    chapterContent,
    pageContent,
    currentPage,
    currentChapter,
    setCurrentPage,
    setCurrentChapter
  } = useChapterContent();

  const {
    tokenBalance,
    chapterLockStatus,
    holderCount = 0,
    currentRequirements = {}
  } = useTokenBalance();

  useEffect(() => {
    const loadChapters = async () => {
      const chapters = await Promise.all(
        Array.from({length: 10}, (_, i) => getChapterMetadata(i + 1))
      );
      setChapterList(chapters.filter(Boolean));
    };
    loadChapters();
  }, []);

  const handlePageChange = (direction: 'prev' | 'next') => {
    if (direction === 'prev') {
      if (currentPage > 1) {
        setCurrentPage(currentPage - 1);
      } else if (currentChapter > 1) {
        setCurrentChapter(currentChapter - 1);
        setCurrentPage(getTotalPages(currentChapter - 1));
      }
    } else {
      const totalPages = getTotalPages(currentChapter);
      if (currentPage < totalPages) {
        setCurrentPage(currentPage + 1);
      } else if (!chapterLockStatus[currentChapter + 1]) {
        setCurrentChapter(currentChapter + 1);
        setCurrentPage(1);
      }
    }
  };

  const handleChapterSelect = (chapter: number) => {
    setCurrentChapter(chapter);
    setCurrentPage(1);
  };

  const handleViewChange = (view: 'book' | 'roadmap') => {
    setCurrentView(view);
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', backgroundColor: '#1a1a1a' }}>
      <Sidebar
        currentChapter={currentChapter}
        currentView={currentView}
        chapterList={chapterList}
        chapterLockStatus={chapterLockStatus}
        tokenBalance={tokenBalance}
        holderCount={holderCount}
        currentRequirements={currentRequirements}
        onChapterSelect={handleChapterSelect}
        onViewChange={handleViewChange}
      />

      <div style={{
        marginLeft: '250px',
        flex: 1,
        padding: '24px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative'
      }}>
        {currentView === 'book' ? (
          <>
            <BookContent
              chapterContent={chapterContent}
              currentChapter={currentChapter}
              currentPage={currentPage}
              pageContent={pageContent}
            />
            <PageNavigation
              currentPage={currentPage}
              currentChapter={currentChapter}
              chapterLockStatus={chapterLockStatus}
              onPageChange={handlePageChange}
            />
          </>
        ) : (
          <RoadmapView />
        )}
      </div>
    </div>
  );
};

export default BookLayout;
